var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import BaseModal from './ComponentModal';
import T from '../Utils/Locale';
import { getGlobalState } from '../Utils/GlobalState';
import Button from './ComponentButton';
const ComponentConditionsModal = ({ title = true, isLoading = false, onClose, onAccept, onDecline }) => {
    const [conditions, setConditions] = useState(null);
    const [isConditionsError, setConditionsError] = useState(false);
    useEffect(() => fetchConditions(), []);
    return (_jsxs(BaseModal, Object.assign({ id: 'reveal-conditions-modal', closeModal: onClose, className: 'reveal-conditions', isWide: true }, { children: [title !== false && _jsx("h2", { children: title === true ? T('conditions.title') : title }), (conditions != null && !isConditionsError) && (_jsx("div", Object.assign({ className: `reveal-conditions__content ${title === false ? 'hide-title' : ''}` }, { children: _jsx("div", { dangerouslySetInnerHTML: { __html: conditions } }) }))), isConditionsError && _jsx("p", Object.assign({ className: 'via-viva-red' }, { children: T('errors.generic') })), _jsxs("div", Object.assign({ className: 'reveal-conditions__actions text-center' }, { children: [_jsx(Button, Object.assign({ classes: 'button transparent', onClick: onDecline }, { children: T('conditions.decline') })), _jsx(Button, Object.assign({ onClick: onAccept, isLoading: isLoading }, { children: T('conditions.accept') }))] }))] })));
    function fetchConditions() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const applicationUrl = getGlobalState('application_url');
                const { data } = yield axios.get(`${applicationUrl}/api/conditions/current`, { withCredentials: true });
                setConditions(data.condition_html);
            }
            catch (_a) {
                setConditionsError(true);
            }
        });
    }
};
ComponentConditionsModal.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    isLoading: PropTypes.bool,
    onClose: PropTypes.func,
    onAccept: PropTypes.func.isRequired,
    onDecline: PropTypes.func.isRequired
};
export default ComponentConditionsModal;
